import type {
  OrderStatus,
  Priority,
  QCRemarkStatus,
  QCSeverity,
  ReportKind,
  RiskLevel,
  Role,
  StageStatus,
} from '@/api/types'

export const orderStatusLabel: Record<OrderStatus, string> = {
  DRAFT: 'Черновик',
  PLANNED: 'Запланирован',
  IN_PRODUCTION: 'В производстве',
  PAUSED: 'На паузе',
  READY: 'Готов',
  SHIPPED: 'Отгружен',
  CANCELLED: 'Отменён',
}

export const riskLabel: Record<RiskLevel, string> = {
  GREEN: 'В норме',
  YELLOW: 'Внимание',
  ORANGE: 'Риск',
  RED: 'Критично',
}

export const priorityLabel: Record<Priority, string> = {
  LOW: 'Низкий',
  NORMAL: 'Обычный',
  HIGH: 'Высокий',
  URGENT: 'Срочный',
}

export const roleLabel: Record<Role, string> = {
  ADMIN: 'Администратор',
  OWNER: 'Владелец',
  PRODUCTION_MANAGER: 'Начальник производства',
  SALES_MANAGER: 'Менеджер продаж',
  DEPARTMENT_MASTER: 'Мастер участка',
  WORKER: 'Сотрудник',
}

export const stageStatusLabel: Record<StageStatus, string> = {
  PENDING: 'Ожидает',
  AVAILABLE: 'Доступен',
  ACCEPTED: 'Принят',
  IN_PROGRESS: 'В работе',
  PAUSED: 'Пауза',
  COMPLETED: 'Завершён',
  TRANSFERRED: 'Передан',
  SKIPPED: 'Пропущен',
  CANCELLED: 'Отменён',
}

export const qcSeverityLabel: Record<QCSeverity, string> = {
  MINOR: 'Незначительное',
  MAJOR: 'Серьёзное',
  CRITICAL: 'Критическое',
}

export const qcStatusLabel: Record<QCRemarkStatus, string> = {
  OPEN: 'Открыто',
  ACKNOWLEDGED: 'Принято',
  RESOLVED: 'Устранено',
  VERIFIED: 'Проверено',
  REJECTED: 'Отклонено',
}

export const reportKindLabel: Record<ReportKind, string> = {
  PROGRESS: 'Ход работ',
  COMPLETION: 'Завершение',
  QC_RESPONSE: 'Ответ ОТК',
  ISSUE: 'Проблема',
  OTHER: 'Другое',
}
